import { render, staticRenderFns } from "./PlayHubAccount.vue?vue&type=template&id=1371488a&scoped=true"
import script from "./PlayHubAccount.vue?vue&type=script&lang=js"
export * from "./PlayHubAccount.vue?vue&type=script&lang=js"
import style0 from "./PlayHubAccount.vue?vue&type=style&index=0&id=1371488a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371488a",
  null
  
)

export default component.exports